import BaseBusinessAPI from '../portal/baseBusinessAPI'

class StudentDisabilityAPI extends BaseBusinessAPI {
  controllerName = 'StudentDisabilitys';
}

export default new StudentDisabilityAPI()
